import React, { useState, useEffect } from "react";
import { 
  Table, 
  Button, 
  Modal, 
  Form, 
  Input, 
  Space, 
  Popconfirm,
  message,
  Card,
  Row,
  Col,
  Typography,
  Tooltip,
  Tag
} from 'antd';
import { 
  PlusOutlined, 
  EditOutlined, 
  DeleteOutlined, 
  TeamOutlined,
  AppstoreOutlined
} from '@ant-design/icons';
import Api from "../../../../services/api";

const { Title } = Typography;

function Studio() {
  const [data, setData] = useState([]);
  const [studio, setStudio] = useState({});
  const [modal, setModal] = useState(false);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleChangePage = (page) => {
    setPage(page);
  }

  const getData = () => {
    setLoading(true);
    Api.get(`/api/studio?page=${page}`)
      .then(result => {
        if (result?.data?.data.length > 0) {
          setData(result.data);
        }
        setLoading(false)
      });
  }

  const handleEditStudio = (item) => {
    setStudio({
      id: item.id,
      name: item.name,
      code: item.code,
    });
    form.setFieldsValue({
      name: item.name,
      code: item.code,
    });
    setModal(true);
  }

  const saveData = () => {
    form.validateFields().then(values => {
      setLoading(true);
      const api = studio?.id ? Api.put(`/api/studio/${studio.id}`, {
        name: values.name,
        code: values.code,
      }) : Api.post(`/api/studio`, {
        name: values.name,
        code: values.code,
      })
      
      api.then(result => {
        setLoading(false)
        if (result.data.code == 0) {
          message.success(studio?.id ? 'Cập nhật studio thành công!' : 'Tạo studio thành công!');
          getData()
          setStudio({})
          setModal(false)
          form.resetFields();
        } else {
          message.error('Có lỗi xảy ra!');
        }
      }).catch(error => {
        setLoading(false);
        message.error('Có lỗi xảy ra!');
      });
    });
  }

  const handleDelete = (item) => {
    setLoading(true);
    Api.delete(`/api/studio/${item.id}`)
      .then(result => {
        setLoading(false);
        if (result.data.code == 0) {
          message.success('Xóa studio thành công!');
          getData()
        } else {
          message.error('Có lỗi xảy ra!');
        }
      }).catch(error => {
        setLoading(false);
        message.error('Có lỗi xảy ra!');
      });
  }

  const columns = [
    {
      title: 'Tên Studio',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => (
        <Space>
          <TeamOutlined style={{ color: '#1890ff' }} />
          <span style={{ fontWeight: 'bold' }}>{text}</span>
        </Space>
      ),
    },
    {
      title: 'Mã Code',
      dataIndex: 'code',
      key: 'code',
      render: (text) => (
        <Tag color="blue">{text}</Tag>
      ),
    },
    {
      title: 'Hành động',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="Chỉnh sửa">
            <Button 
              type="primary" 
              icon={<EditOutlined />} 
              size="small"
              onClick={() => handleEditStudio(record)}
            />
          </Tooltip>
          <Tooltip title="Xóa">
            <Popconfirm
              title="Bạn có chắc chắn muốn xóa studio này?"
              description="Tất cả app và user thuộc studio này sẽ bị ảnh hưởng."
              onConfirm={() => handleDelete(record)}
              okText="Có"
              cancelText="Không"
            >
              <Button 
                type="primary" 
                danger 
                icon={<DeleteOutlined />} 
                size="small"
              />
            </Popconfirm>
          </Tooltip>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    getData();
  }, [page]);

  return (
    <>
      <div className="background-second-dashboard">
        <section className="main__content-dashbard">
          <div className="container-fluid">
            <Card>
              <Row justify="space-between" align="middle" style={{ marginBottom: '24px' }}>
                <Col>
                  <Title level={4} style={{ margin: 0, fontSize: '18px' }}>
                    Quản lý Studio
                  </Title>
                </Col>
                <Col>
                  <Button 
                    type="primary" 
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setStudio({});
                      form.resetFields();
                      setModal(true);
                    }}
                    size="small"
                  >
                    Tạo Studio
                  </Button>
                </Col>
              </Row>

              <Table
                columns={columns}
                dataSource={data.data || []}
                rowKey="id"
                loading={loading}
                bordered
                pagination={{
                  current: page,
                  total: data.total || 0,
                  pageSize: data.per_page || 10,
                  onChange: handleChangePage,
                  showSizeChanger: false,
                  showQuickJumper: false,
                  showTotal: (total, range) => 
                    `${range[0]}-${range[1]} của ${total} studio`,
                }}
                scroll={{ x: 600 }}
              />
            </Card>
          </div>
        </section>
      </div>

      <Modal
        title={studio?.id ? 'Chỉnh sửa Studio' : 'Tạo Studio mới'}
        open={modal}
        onCancel={() => {
          setModal(false);
          form.resetFields();
        }}
        onOk={saveData}
        confirmLoading={loading}
        width={500}
      >
        <Form
          form={form}
          layout="vertical"
        >
          <Form.Item
            label="Tên Studio"
            name="name"
            rules={[{ required: true, message: 'Vui lòng nhập tên studio!' }]}
          >
            <Input placeholder="Nhập tên studio" />
          </Form.Item>
          
          <Form.Item
            label="Mã Code"
            name="code"
            rules={[{ required: true, message: 'Vui lòng nhập mã code!' }]}
          >
            <Input placeholder="Nhập mã code" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
}

export default Studio;